module.exports = __webpack_public_path__ + "img/brand-scania.1f93b614.png";